<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <VehicleBrandForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import VehicleBrandForm from '@/components/settings/test-registers/vehicleBrands/VehicleBrandsForm'

export default {
  name: 'VehicleBrandAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    VehicleBrandForm
  }
}
</script>
